import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const articles = [
  {
    id: 1,
    category: 'Política',
    title: 'Câmara aprova pacote fiscal com impacto direto nas famílias brasileiras',
    excerpt: 'Medidas entram em vigor no próximo trimestre e prometem redefinir o cenário econômico nacional com cortes e redistribuição de verbas.',
    image: 'https://public.readdy.ai/ai/img_res/f07c8543a3b377f319aac9dc3b2ffd50.jpg',
    date: '07 Abr 2026',
    readTime: '5 min',
  },
  {
    id: 2,
    category: 'Economia',
    title: 'Dólar recua após sinalização do Banco Central sobre taxa de juros',
    excerpt: 'Mercado financeiro reagiu positivamente ao comunicado oficial, com o câmbio encerrando o pregão abaixo dos R$ 5,10 pela primeira vez em meses.',
    image: 'https://readdy.ai/api/search-image?query=Brazilian%20financial%20market%20stock%20exchange%20trading%20floor%20with%20screens%20showing%20charts%20and%20graphs%20in%20a%20modern%20office%20environment%20with%20neutral%20tones&width=600&height=400&seq=lp002&orientation=landscape',
    date: '07 Abr 2026',
    readTime: '4 min',
  },
  {
    id: 3,
    category: 'Cidade',
    title: 'Prefeitura anuncia revitalização do centro histórico com investimento de R$ 80 milhões',
    excerpt: 'Projeto prevê restauração de fachadas, novo calçamento e iluminação pública em 14 quarteirões do núcleo original da cidade.',
    image: 'https://readdy.ai/api/search-image?query=historic%20city%20center%20urban%20revitalization%20project%20with%20classic%20architecture%20buildings%20cobblestone%20streets%20and%20warm%20afternoon%20light%20in%20a%20Brazilian%20city&width=600&height=400&seq=lp003&orientation=landscape',
    date: '06 Abr 2026',
    readTime: '6 min',
  },
  {
    id: 4,
    category: 'Cultura',
    title: 'Festival de literatura reúne 40 autores nacionais no maior evento do estado',
    excerpt: 'Programação inclui lançamentos, mesas-redondas e oficinas gratuitas abertas ao público durante cinco dias de celebração literária.',
    image: 'https://readdy.ai/api/search-image?query=literary%20festival%20book%20fair%20with%20authors%20signing%20books%20elegant%20indoor%20venue%20with%20warm%20lighting%20bookshelves%20and%20cultured%20audience%20in%20Brazil&width=600&height=400&seq=lp004&orientation=landscape',
    date: '06 Abr 2026',
    readTime: '3 min',
  },
  {
    id: 5,
    category: 'Internacional',
    title: 'Cúpula do G20 define novas metas climáticas para 2035 com adesão de 18 países',
    excerpt: 'Acordo histórico estabelece redução de 45% nas emissões de carbono e cria fundo de US$ 200 bilhões para nações em desenvolvimento.',
    image: 'https://readdy.ai/api/search-image?query=G20%20international%20summit%20diplomacy%20world%20leaders%20meeting%20formal%20conference%20room%20with%20flags%20and%20elegant%20decor%20neutral%20professional%20atmosphere&width=600&height=400&seq=lp005&orientation=landscape',
    date: '05 Abr 2026',
    readTime: '7 min',
  },
  {
    id: 6,
    category: 'Esportes',
    title: 'Seleção brasileira convoca 26 atletas para amistosos de preparação para a Copa',
    excerpt: 'Lista traz três estreantes e a volta de veteranos após recuperação de lesões. Comissão técnica aposta em equilíbrio entre experiência e juventude.',
    image: 'https://readdy.ai/api/search-image?query=Brazilian%20football%20soccer%20national%20team%20training%20session%20on%20green%20pitch%20with%20players%20in%20yellow%20jerseys%20dynamic%20action%20photography%20professional%20sports&width=600&height=400&seq=lp006&orientation=landscape',
    date: '05 Abr 2026',
    readTime: '4 min',
  },
];

const features = [
  { icon: 'ri-flashlight-line', title: 'Notícias em tempo real', desc: 'Cobertura ao vivo dos principais acontecimentos locais, nacionais e internacionais, 24 horas por dia.' },
  { icon: 'ri-newspaper-line', title: 'Edição impressa premium', desc: 'Jornal físico de alta qualidade entregue na sua porta, com diagramação editorial profissional.' },
  { icon: 'ri-lock-star-line', title: 'Conteúdo exclusivo', desc: 'Reportagens investigativas, entrevistas e análises que você não encontra em nenhum outro veículo.' },
  { icon: 'ri-search-eye-line', title: 'Análises profundas', desc: 'Contexto, história e perspectiva em cada matéria. Jornalismo que vai além do fato imediato.' },
  { icon: 'ri-qr-code-line', title: 'Integração com QR codes', desc: 'Cada edição impressa conecta você ao conteúdo digital complementar com um simples escaneamento.' },
  { icon: 'ri-shield-check-line', title: 'Independência editorial', desc: 'Sem vínculos políticos ou corporativos. Nossa única lealdade é com a verdade e com o leitor.' },
];

const categoryColors: Record<string, string> = {
  Política: '#C41230',
  Economia: '#EA580C',
  Cidade: '#0891B2',
  Cultura: '#7C3AED',
  Internacional: '#1D4ED8',
  Esportes: '#16A34A',
};

export default function LandingPage() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [subscribeOpen, setSubscribeOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSubscribe = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new URLSearchParams(new FormData(form) as unknown as Record<string, string>);
    setSubmitting(true);
    try {
      await fetch('https://readdy.ai/api/form/d7ao4ef6e3lk9704a1ag', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white font-['Inter']">

      {/* ── NAVBAR ── */}
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white border-b border-[#E0E0E0]' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/cb3f25066178f57a7b4ff6ec1e98d674/3adf4e78d4ccc80f9408185bfae7ead8.png"
              alt="Jardel City Post"
              className="h-10 w-auto object-contain"
            />
          </div>

          {/* Nav links */}
          <nav className="hidden md:flex items-center gap-7">
            {['Política', 'Cidade', 'Economia', 'Cultura', 'Esportes'].map((item) => (
              <a
                key={item}
                href="#noticias"
                className={`text-xs font-bold uppercase tracking-widest transition-colors whitespace-nowrap ${scrolled ? 'text-[#333333] hover:text-[#C41230]' : 'text-white hover:text-[#DDDDDD]'}`}
              >
                {item}
              </a>
            ))}
          </nav>

          {/* CTA */}
          <div className="flex items-center gap-3">
            <a
              href="#noticias"
              className={`hidden md:block text-xs font-bold uppercase tracking-widest px-4 py-2 border transition-all whitespace-nowrap cursor-pointer ${scrolled ? 'border-[#111111] text-[#111111] hover:bg-[#111111] hover:text-white' : 'border-white text-white hover:bg-white hover:text-[#111111]'}`}
            >
              Acessar notícias
            </a>
            <button
              onClick={() => setSubscribeOpen(true)}
              className="text-xs font-bold uppercase tracking-widest px-4 py-2 bg-[#C41230] text-white border border-[#C41230] hover:bg-[#A00E25] transition-all whitespace-nowrap cursor-pointer"
            >
              Assinar
            </button>
          </div>
        </div>
      </header>

      {/* ── HERO ── */}
      <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=vintage%20newspaper%20printing%20press%20editorial%20room%20with%20dramatic%20lighting%20ink%20and%20paper%20textures%20monochromatic%20black%20and%20white%20atmosphere%20professional%20journalism%20heritage&width=1440&height=900&seq=hero001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/80"></div>
          {/* Subtle grid overlay */}
          <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 39px, rgba(255,255,255,0.3) 39px, rgba(255,255,255,0.3) 40px), repeating-linear-gradient(90deg, transparent, transparent 39px, rgba(255,255,255,0.3) 39px, rgba(255,255,255,0.3) 40px)' }}></div>
        </div>

        <div className="relative z-10 w-full max-w-5xl mx-auto px-6 text-center">
          {/* Masthead date line */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="h-px w-16 bg-white/40"></div>
            <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/70">Segunda-feira, 7 de Abril de 2026 · Edição Nº 14.820</p>
            <div className="h-px w-16 bg-white/40"></div>
          </div>

          {/* Logo */}
          <div className="mb-6 flex justify-center">
            <img
              src="https://static.readdy.ai/image/cb3f25066178f57a7b4ff6ec1e98d674/3adf4e78d4ccc80f9408185bfae7ead8.png"
              alt="Jardel City Post"
              className="h-20 w-auto object-contain brightness-0 invert"
            />
          </div>

          {/* Divider */}
          <div className="flex items-center justify-center gap-2 mb-8">
            <div className="h-px w-24 bg-white/50"></div>
            <div className="w-1.5 h-1.5 bg-[#C41230]"></div>
            <div className="h-px w-24 bg-white/50"></div>
          </div>

          {/* Headline */}
          <h1 className="font-['Playfair_Display'] text-5xl md:text-7xl font-bold text-white leading-[1.1] mb-6 tracking-tight">
            A história viva<br />
            <em className="not-italic text-[#E8E8E8]">da notícia.</em>
          </h1>

          {/* Subheadline */}
          <p className="font-['Source_Serif_4'] text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed mb-10">
            40 anos de jornalismo. Agora com verdade e sem amarras.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#noticias"
              className="px-8 py-3.5 bg-white text-[#111111] text-xs font-bold uppercase tracking-widest hover:bg-[#F0F0F0] transition-all cursor-pointer whitespace-nowrap border border-white"
            >
              Acessar notícias
            </a>
            <button
              onClick={() => setSubscribeOpen(true)}
              className="px-8 py-3.5 bg-[#C41230] text-white text-xs font-bold uppercase tracking-widest hover:bg-[#A00E25] transition-all cursor-pointer whitespace-nowrap border border-[#C41230]"
            >
              Assinar edição impressa
            </button>
          </div>

          {/* Stats */}
          <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-0 border border-white/20 divide-y sm:divide-y-0 sm:divide-x divide-white/20 max-w-2xl mx-auto">
            {[
              { value: '40+', label: 'Anos de história' },
              { value: '14.820', label: 'Edições publicadas' },
              { value: '120k+', label: 'Leitores mensais' },
            ].map((stat) => (
              <div key={stat.label} className="flex-1 px-8 py-4 text-center">
                <p className="font-['Playfair_Display'] text-2xl font-bold text-white">{stat.value}</p>
                <p className="text-[10px] uppercase tracking-widest text-white/60 mt-0.5">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-down-line text-white/60 text-lg"></i>
          </div>
        </div>
      </section>

      {/* ── POSITIONING ── */}
      <section className="bg-white border-b border-[#E0E0E0]">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="section-label mb-4">Nossa proposta</p>
              <div className="wapo-divider pb-4 mb-6">
                <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-[#111111] leading-tight">
                  Nem só digital.<br />Nem só impresso.
                </h2>
              </div>
              <p className="font-['Source_Serif_4'] text-base text-[#444444] leading-relaxed mb-5">
                O <strong>Jardel City Post</strong> nasceu em papel e cresceu com a cidade. Hoje, somos o único veículo da região que une a profundidade do jornalismo impresso com a velocidade e o alcance do digital — sem abrir mão de nenhum dos dois.
              </p>
              <p className="font-['Source_Serif_4'] text-base text-[#444444] leading-relaxed mb-8">
                Para o leitor que ainda aprecia o ritual do jornal na mesa do café da manhã, e para quem precisa da notícia no celular em tempo real. Duas gerações. Uma só verdade.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex items-center gap-3 p-4 border border-[#E0E0E0] flex-1">
                  <div className="w-10 h-10 bg-[#111111] flex items-center justify-center flex-shrink-0">
                    <i className="ri-newspaper-line text-white text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-widest text-[#111111]">Impresso</p>
                    <p className="text-[11px] text-[#777777] font-['Source_Serif_4']">Entrega semanal em casa</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 p-4 border border-[#E0E0E0] flex-1">
                  <div className="w-10 h-10 bg-[#C41230] flex items-center justify-center flex-shrink-0">
                    <i className="ri-smartphone-line text-white text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs font-bold uppercase tracking-widest text-[#111111]">Digital</p>
                    <p className="text-[11px] text-[#777777] font-['Source_Serif_4']">Acesso 24h em qualquer tela</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative overflow-hidden border border-[#E0E0E0]">
                <img
                  src="https://readdy.ai/api/search-image?query=elegant%20newspaper%20being%20read%20at%20a%20cafe%20table%20with%20coffee%20cup%20morning%20light%20warm%20atmosphere%20classic%20journalism%20print%20edition%20high%20quality%20paper&width=700&height=500&seq=pos001&orientation=landscape"
                  alt="Edição impressa do Jardel City Post"
                  className="w-full h-[380px] object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-5">
                  <p className="text-[10px] font-bold uppercase tracking-widest text-white/70">Edição impressa</p>
                  <p className="font-['Playfair_Display'] text-lg font-bold text-white">Qualidade que você sente nas mãos</p>
                </div>
              </div>
              {/* Floating badge */}
              <div className="absolute -top-4 -right-4 bg-[#C41230] text-white p-4 border-4 border-white">
                <p className="font-['Playfair_Display'] text-2xl font-bold leading-none">40</p>
                <p className="text-[9px] uppercase tracking-widest leading-tight">anos</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── AUTHORITY ── */}
      <section className="bg-[#111111]">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Photo */}
            <div className="relative order-2 lg:order-1">
              <div className="relative overflow-hidden border-4 border-[#333333]">
                <img
                  src="https://readdy.ai/api/search-image?query=distinguished%20senior%20male%20journalist%20in%20his%2060s%20wearing%20a%20suit%20sitting%20at%20a%20desk%20with%20newspapers%20and%20books%20in%20a%20classic%20editorial%20office%20warm%20professional%20portrait%20photography&width=600&height=700&seq=auth001&orientation=portrait"
                  alt="Jornalista Renato Silva"
                  className="w-full h-[420px] object-cover object-top"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-5">
                  <p className="font-['Playfair_Display'] text-xl font-bold text-white">Renato Silva</p>
                  <p className="text-[11px] text-white/60 font-['Source_Serif_4'] mt-0.5">MTB 32945 · Jornalista fundador</p>
                </div>
              </div>
            </div>

            {/* Text */}
            <div className="order-1 lg:order-2">
              <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#C41230] mb-4">Autoridade editorial</p>
              <div className="border-t-2 border-[#C41230] pt-5 mb-6">
                <h2 className="font-['Playfair_Display'] text-4xl font-bold text-white leading-tight">
                  Mais de 40 anos<br />contando a verdade.
                </h2>
              </div>
              <p className="font-['Source_Serif_4'] text-base text-[#AAAAAA] leading-relaxed mb-8">
                O <strong className="text-white">Jornalista Renato Silva</strong> fundou o Jardel City Post com uma missão simples: informar sem medo, sem viés e sem patrão. Quatro décadas depois, essa missão continua sendo a bússola de cada edição.
              </p>

              <div className="space-y-0 border border-[#333333]">
                {[
                  { icon: 'ri-award-line', title: 'Experiência comprovada', desc: 'Mais de 40 anos de cobertura jornalística ininterrupta, com presença em todos os grandes eventos da região.' },
                  { icon: 'ri-shield-line', title: 'Independência total', desc: 'Sem financiamento político, sem anunciantes que condicionam a pauta. Sustentado pelos leitores.' },
                  { icon: 'ri-scales-3-line', title: 'Sem viés ideológico', desc: 'Os fatos falam por si. Nossa cobertura é equilibrada, verificada e comprometida com a pluralidade.' },
                ].map((item, i, arr) => (
                  <div key={i} className={`flex items-start gap-4 p-5 ${i < arr.length - 1 ? 'border-b border-[#333333]' : ''}`}>
                    <div className="w-9 h-9 border border-[#C41230] flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className={`${item.icon} text-[#C41230] text-base`}></i>
                    </div>
                    <div>
                      <p className="text-xs font-bold uppercase tracking-widest text-white mb-1">{item.title}</p>
                      <p className="text-[12px] text-[#888888] font-['Source_Serif_4'] leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-6 p-4 border-l-4 border-l-[#C41230] border border-[#333333] bg-[#1A1A1A]">
                <p className="font-['Playfair_Display'] text-lg italic text-white leading-snug">
                  &ldquo;O jornalismo não é profissão. É vocação. E vocação não se negocia.&rdquo;
                </p>
                <p className="text-[10px] uppercase tracking-widest text-[#888888] mt-2">— Renato Silva, MTB 32945</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section className="bg-[#F8F8F8] border-y border-[#E0E0E0]">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <div className="text-center mb-12">
            <p className="section-label mb-3">Por que assinar</p>
            <div className="flex items-center justify-center gap-3 mb-5">
              <div className="h-px w-12 bg-[#E0E0E0]"></div>
              <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#111111]">
                Tudo que o jornalismo<br />de verdade oferece
              </h2>
              <div className="h-px w-12 bg-[#E0E0E0]"></div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 border border-[#E0E0E0]">
            {features.map((f, i) => (
              <div
                key={i}
                className={`p-7 bg-white border-[#E0E0E0] hover:bg-[#F8F8F8] transition-colors group
                  ${i % 3 !== 2 ? 'lg:border-r' : ''}
                  ${i < 3 ? 'border-b' : ''}
                  ${i % 2 === 0 ? 'sm:border-r lg:border-r-0' : ''}
                  ${i % 2 === 0 && i % 3 !== 2 ? 'lg:border-r' : ''}
                `}
              >
                <div className="w-10 h-10 border border-[#E0E0E0] group-hover:border-[#C41230] group-hover:bg-[#C41230]/5 flex items-center justify-center mb-4 transition-all">
                  <i className={`${f.icon} text-[#C41230] text-lg`}></i>
                </div>
                <h3 className="font-['Playfair_Display'] text-base font-bold text-[#111111] mb-2">{f.title}</h3>
                <p className="text-[12px] text-[#666666] font-['Source_Serif_4'] leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── ARTICLES ── */}
      <section id="noticias" className="bg-white border-b border-[#E0E0E0]">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <div className="flex items-end justify-between mb-8 border-b-2 border-[#111111] pb-4">
            <div>
              <p className="section-label mb-1">Últimas edições</p>
              <h2 className="font-['Playfair_Display'] text-3xl font-bold text-[#111111]">Notícias em destaque</h2>
            </div>
            <a href="#" className="text-[10px] font-bold uppercase tracking-widest text-[#C41230] hover:underline whitespace-nowrap cursor-pointer">
              Ver todas →
            </a>
          </div>

          {/* Featured + grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-0 border border-[#E0E0E0]">
            {/* Main featured */}
            <div
              className="lg:col-span-2 border-b lg:border-b-0 lg:border-r border-[#E0E0E0] group cursor-pointer"
              onClick={() => navigate(`/article/${articles[0].id}`)}
            >
              <div className="overflow-hidden">
                <img
                  src={articles[0].image}
                  alt={articles[0].title}
                  className="w-full h-[300px] object-cover object-top group-hover:scale-[1.02] transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-[10px] font-bold uppercase tracking-widest" style={{ color: categoryColors[articles[0].category] || '#C41230' }}>
                    {articles[0].category}
                  </span>
                  <span className="text-[10px] text-[#999999]">·</span>
                  <span className="text-[10px] text-[#999999] font-['Source_Serif_4']">{articles[0].date}</span>
                  <span className="text-[10px] text-[#999999]">·</span>
                  <span className="text-[10px] text-[#999999] font-['Source_Serif_4']">{articles[0].readTime} de leitura</span>
                </div>
                <h3 className="font-['Playfair_Display'] text-2xl font-bold text-[#111111] leading-tight mb-3 group-hover:text-[#C41230] transition-colors">
                  {articles[0].title}
                </h3>
                <p className="font-['Source_Serif_4'] text-sm text-[#555555] leading-relaxed">{articles[0].excerpt}</p>
              </div>
            </div>

            {/* Side articles */}
            <div className="flex flex-col divide-y divide-[#E0E0E0]">
              {articles.slice(1, 4).map((article) => (
                <div
                  key={article.id}
                  className="flex gap-3 p-4 group cursor-pointer hover:bg-[#FAFAFA] transition-colors"
                  onClick={() => navigate(`/article/${article.id}`)}
                >
                  <div className="w-20 h-20 overflow-hidden flex-shrink-0 border border-[#E0E0E0]">
                    <img src={article.image} alt={article.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <span className="text-[9px] font-bold uppercase tracking-widest" style={{ color: categoryColors[article.category] || '#C41230' }}>
                      {article.category}
                    </span>
                    <h4 className="font-['Playfair_Display'] text-sm font-bold text-[#111111] leading-snug mt-0.5 group-hover:text-[#C41230] transition-colors line-clamp-3">
                      {article.title}
                    </h4>
                    <p className="text-[10px] text-[#999999] mt-1 font-['Source_Serif_4']">{article.date}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom row */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-0 border-x border-b border-[#E0E0E0] mt-0">
            {articles.slice(3, 6).map((article, i) => (
              <div
                key={article.id}
                className={`p-5 group cursor-pointer hover:bg-[#FAFAFA] transition-colors ${i < 2 ? 'border-r border-[#E0E0E0]' : ''} border-t border-[#E0E0E0]`}
                onClick={() => navigate(`/article/${article.id}`)}
              >
                <div className="overflow-hidden mb-3 border border-[#E0E0E0]">
                  <img src={article.image} alt={article.title} className="w-full h-36 object-cover object-top group-hover:scale-[1.02] transition-transform duration-300" />
                </div>
                <span className="text-[9px] font-bold uppercase tracking-widest" style={{ color: categoryColors[article.category] || '#C41230' }}>
                  {article.category}
                </span>
                <h4 className="font-['Playfair_Display'] text-sm font-bold text-[#111111] leading-snug mt-1 mb-2 group-hover:text-[#C41230] transition-colors">
                  {article.title}
                </h4>
                <p className="text-[11px] text-[#666666] font-['Source_Serif_4'] leading-relaxed line-clamp-2">{article.excerpt}</p>
                <p className="text-[10px] text-[#999999] mt-2 font-['Source_Serif_4']">{article.date} · {article.readTime}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20dark%20editorial%20newspaper%20texture%20with%20ink%20patterns%20and%20typography%20fragments%20moody%20dramatic%20black%20background%20with%20subtle%20paper%20grain%20texture&width=1440&height=500&seq=cta001&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-[#111111]/85"></div>
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 py-24 text-center">
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#C41230] mb-5">Não perca nenhuma edição</p>
          <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl font-bold text-white leading-tight mb-5">
            A verdade não espera.<br />
            <em className="not-italic text-[#DDDDDD]">Acesse agora.</em>
          </h2>
          <p className="font-['Source_Serif_4'] text-base text-white/70 max-w-xl mx-auto mb-10 leading-relaxed">
            Junte-se a mais de 120 mil leitores que escolheram o jornalismo independente, profundo e sem amarras do Jardel City Post.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#noticias"
              className="px-8 py-3.5 border border-white text-white text-xs font-bold uppercase tracking-widest hover:bg-white hover:text-[#111111] transition-all cursor-pointer whitespace-nowrap"
            >
              Ler notícias
            </a>
            <button
              onClick={() => setSubscribeOpen(true)}
              className="px-8 py-3.5 bg-[#C41230] text-white text-xs font-bold uppercase tracking-widest hover:bg-[#A00E25] transition-all cursor-pointer whitespace-nowrap border border-[#C41230]"
            >
              Assinar jornal
            </button>
          </div>
        </div>
      </section>

      {/* ── FOOTER ── */}
      <footer className="bg-[#F8F8F8] border-t-2 border-[#111111]">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
            {/* Brand */}
            <div>
              <img
                src="https://static.readdy.ai/image/cb3f25066178f57a7b4ff6ec1e98d674/3adf4e78d4ccc80f9408185bfae7ead8.png"
                alt="Jardel City Post"
                className="h-12 w-auto object-contain mb-4"
              />
              <p className="font-['Source_Serif_4'] text-sm text-[#555555] leading-relaxed mb-4">
                40 anos de jornalismo independente, comprometido com a verdade e com a cidade.
              </p>
              <p className="text-[11px] text-[#888888] font-['Source_Serif_4']">
                <strong className="text-[#444444]">Jornalista Renato Silva</strong><br />
                MTB 32945
              </p>
            </div>

            {/* Editorias */}
            <div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-[#111111] mb-4 border-b border-[#E0E0E0] pb-2">Editorias</p>
              <div className="grid grid-cols-2 gap-1">
                {['Política', 'Cidade', 'Economia', 'Cultura', 'Esportes', 'Internacional', 'Ciência', 'Opinião'].map((link) => (
                  <a
                    key={link}
                    href="#"
                    className="text-xs text-[#555555] hover:text-[#C41230] font-['Source_Serif_4'] py-1 transition-colors"
                  >
                    {link}
                  </a>
                ))}
              </div>
            </div>

            {/* Contact */}
            <div>
              <p className="text-[10px] font-bold uppercase tracking-widest text-[#111111] mb-4 border-b border-[#E0E0E0] pb-2">Contato</p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-global-line text-[#C41230] text-sm"></i>
                  </div>
                  <a href="https://www.jardelcitypost.com.br" rel="nofollow" className="text-xs text-[#555555] hover:text-[#C41230] font-['Source_Serif_4'] transition-colors">
                    www.jardelcitypost.com.br
                  </a>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-[#C41230] text-sm"></i>
                  </div>
                  <a href="mailto:redacao@jardelcitypost.com.br" rel="nofollow" className="text-xs text-[#555555] hover:text-[#C41230] font-['Source_Serif_4'] transition-colors">
                    redacao@jardelcitypost.com.br
                  </a>
                </div>
              </div>
              <div className="mt-5">
                <p className="text-[10px] font-bold uppercase tracking-widest text-[#111111] mb-3">Assine agora</p>
                <button
                  onClick={() => setSubscribeOpen(true)}
                  className="w-full py-2.5 bg-[#111111] text-white text-[10px] font-bold uppercase tracking-widest hover:bg-[#333333] transition-all cursor-pointer whitespace-nowrap"
                >
                  Assinar o jornal
                </button>
              </div>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-[#E0E0E0] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-[10px] text-[#888888] font-['Source_Serif_4']">
              © 2026 Jardel City Post. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4">
              {['Política de Privacidade', 'Termos de Uso', 'Anuncie'].map((link) => (
                <a key={link} href="#" rel="nofollow" className="text-[10px] text-[#888888] hover:text-[#C41230] font-['Source_Serif_4'] transition-colors whitespace-nowrap">
                  {link}
                </a>
              ))}
            </div>
          </div>
        </div>
      </footer>

      {/* ── SUBSCRIBE MODAL ── */}
      {subscribeOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/70" onClick={() => { setSubscribeOpen(false); setSubmitted(false); }}></div>
          <div className="relative bg-white w-full max-w-md border-t-4 border-t-[#C41230]">
            {/* Modal header */}
            <div className="border-b-2 border-[#111111] px-6 py-4 flex items-center justify-between">
              <div>
                <p className="text-[10px] font-bold uppercase tracking-widest text-[#C41230]">Assinatura</p>
                <h3 className="font-['Playfair_Display'] text-lg font-bold text-[#111111]">Assinar Jardel City Post</h3>
              </div>
              <button
                onClick={() => { setSubscribeOpen(false); setSubmitted(false); }}
                className="w-8 h-8 flex items-center justify-center border border-[#E0E0E0] hover:border-[#111111] hover:bg-[#111111] hover:text-white transition-all cursor-pointer"
              >
                <i className="ri-close-line text-sm"></i>
              </button>
            </div>

            {submitted ? (
              <div className="p-8 text-center">
                <div className="w-12 h-12 bg-[#16A34A]/10 border border-[#16A34A] flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-[#16A34A] text-xl"></i>
                </div>
                <h4 className="font-['Playfair_Display'] text-xl font-bold text-[#111111] mb-2">Assinatura recebida!</h4>
                <p className="font-['Source_Serif_4'] text-sm text-[#555555] leading-relaxed">
                  Obrigado pelo seu interesse. Nossa equipe entrará em contato em breve para confirmar os detalhes da sua assinatura.
                </p>
                <button
                  onClick={() => { setSubscribeOpen(false); setSubmitted(false); }}
                  className="mt-6 px-6 py-2.5 bg-[#111111] text-white text-[10px] font-bold uppercase tracking-widest hover:bg-[#333333] transition-all cursor-pointer whitespace-nowrap"
                >
                  Fechar
                </button>
              </div>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleSubscribe}
                className="p-6 space-y-4"
              >
                <div>
                  <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-1.5">Nome completo</label>
                  <input
                    name="nome"
                    type="text"
                    required
                    placeholder="Seu nome"
                    className="w-full px-3 py-2.5 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']"
                  />
                </div>
                <div>
                  <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-1.5">E-mail</label>
                  <input
                    name="email"
                    type="email"
                    required
                    placeholder="seu@email.com"
                    className="w-full px-3 py-2.5 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']"
                  />
                </div>
                <div>
                  <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-1.5">Telefone</label>
                  <input
                    name="telefone"
                    type="tel"
                    placeholder="(00) 00000-0000"
                    className="w-full px-3 py-2.5 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']"
                  />
                </div>
                <div>
                  <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-1.5">Tipo de assinatura</label>
                  <select
                    name="tipo_assinatura"
                    required
                    className="w-full px-3 py-2.5 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] cursor-pointer bg-white font-['Source_Serif_4']"
                  >
                    <option value="">Selecione...</option>
                    <option value="digital">Digital — Acesso online completo</option>
                    <option value="impresso">Impresso — Entrega semanal em casa</option>
                    <option value="combo">Combo — Digital + Impresso</option>
                  </select>
                </div>
                <div>
                  <label className="block text-[10px] font-bold uppercase tracking-widest text-[#555555] mb-1.5">Endereço (para entrega impressa)</label>
                  <input
                    name="endereco"
                    type="text"
                    placeholder="Rua, número, bairro, cidade"
                    className="w-full px-3 py-2.5 text-sm border border-[#CCCCCC] focus:outline-none focus:border-[#111111] font-['Source_Serif_4']"
                  />
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full py-3 bg-[#C41230] text-white text-xs font-bold uppercase tracking-widest hover:bg-[#A00E25] transition-all cursor-pointer whitespace-nowrap disabled:opacity-60 flex items-center justify-center gap-2"
                >
                  {submitting ? (
                    <>
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-loader-4-line animate-spin"></i>
                      </div>
                      Enviando...
                    </>
                  ) : 'Confirmar assinatura'}
                </button>
                <p className="text-[10px] text-[#999999] text-center font-['Source_Serif_4']">
                  Ao assinar, você concorda com nossa Política de Privacidade.
                </p>
              </form>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
